import { textChooser } from "../../common/util/textChooser";
import { useUser } from "../../common/hooks/User";
import { CardSummary, ISummary } from "../../common/components/card/summary";
import { CardDocument } from "../../common/components/card/documents";
import { genderValues } from "../../common/util/GlobalData";
import { useIdToText } from "../../common/hooks/IdToText";
import { formatCurrency } from "../../common/helpers/utilities";
import moment from 'moment';
import './profileSummary.scss';

export const ProfileSummary = ({ countries }: any) => {
  const userData = useUser().getDataAll();
  const { converIdToText } = useIdToText();

  const userAddress = userData.addresses[0];

  const personalData: ISummary[] = [
    {
      summarySubTitle: textChooser("txt126"),
      summaryColumns: [
        {   // correo
          colTitle: textChooser("txt38"),
          colContent: userData.email,
        },
        {   // telefono
          colTitle: textChooser("txt32"),
          colContent: userData.cellPhone,
        },
        {   // tipo documento
          colTitle: textChooser("txt73"),
          colContent: converIdToText(userData.documentType, "documents"),
        },
        {   // numero documento
          colTitle: textChooser("txt74"),
          colContent: userData.documentValue,
        },
        {   // fecha nacimiento
          colTitle: textChooser("txt93"),
          colContent: userData.birthAt ? moment((new Date(userData.birthAt))).format('DD - MM - YYYY') : ""
        },
        {   // genero/sexo
          colTitle: textChooser("txt94"),
          colContent: genderValues.find(g => userData.gender === g.value)?.label ?? "",
        }
      ]
    },
    {
      summarySubTitle: textChooser("txt95"),
      summaryColumns: [
        {   // pais
          colTitle: textChooser("txt96"),
          colContent: countries?.find((o: any) => o.idCountry === +userAddress?.address)?.country ?? "",
        },
        {   // departamento
          colTitle: userAddress && userAddress.address === "1" ? textChooser("txt97") : "",
          colContent: userAddress && userAddress.address === "1" ? converIdToText(userAddress?.location, "geoDepartments") : "",
        },
      ]
    },
    {
      summarySubTitle: textChooser("txt127"),
      summaryColumns: [
        {   // espectativa salarial
          colTitle: textChooser("txt75"),
          colContent: userData.salaryRange ? formatCurrency(userData.salaryRange) : textChooser("txt135"),
        }
      ]
    }
  ];

  const experienceData: ISummary[] = userData.workExperience.map((wk) => ({
    summaryColumns: [
      {   // nombre compania
        colTitle: textChooser("txt101"),
        colContent: wk.jobName,
      },
      {   // sector
        colTitle: textChooser("txt104"),
        colContent: converIdToText(wk.sector, 'sectors'),
      },
      {   // sector
        colTitle: textChooser("txt102"),
        colContent: converIdToText(wk.field, 'areas'),
      },
      {   // posicion
        colTitle: textChooser("txt103"),
        colContent: converIdToText(wk.hierarchy, 'positions'),
      },
      {   // fecha inicio
        colTitle: textChooser("txt105"),
        // colContent: wk.startDate,
        colContent: moment((new Date(wk.startAt))).format('DD - MM - YYYY'),
      },
      {   // fecha fin
        colTitle: textChooser("txt106"),
        // colContent: wk.finishAt,
        colContent: wk.finishAt ? moment((new Date(wk.finishAt))).format('DD - MM - YYYY') : textChooser("txt179"),
      }
    ]
  }));

  const academicsData: ISummary[] = userData.formationInfo.map((fi) => ({
    summaryColumns: [
      {   // profesion
        colTitle: textChooser("txt113"),
        colContent: converIdToText(fi.career, 'professions'),
      },
      {   // grado
        colTitle: textChooser("txt114"),
        // colContent: fi.hasCompleted ? "yes" : " no",
        colContent: converIdToText(fi.type, 'grades')
      },
      {   // centro de estudios
        colTitle: textChooser("txt115"),
        colContent: converIdToText(fi.college, 'universities'),
      },
    ]
  }));

  return (
    <div>
      <section className="profile-section">
        <CardSummary
          summaryTitle={textChooser("txt77")}
          summaryContent={personalData}
          isGray
        />

        {experienceData.map((experience, index) =>
          <CardSummary
            summaryTitle={!index ? textChooser("txt78") : ""}
            summaryContent={[experience]}
            key={`experience${index}`}
            isGray
          />
        )}

        {academicsData.map((academics, index) =>
          <CardSummary
            summaryTitle={!index ? textChooser("txt109") : ""}
            summaryContent={[academics]}
            key={`academics${index}`}
            isGray
          />
        )}

        {userData.nameCurriculumDocument && (
          <CardSummary summaryTitle={textChooser("txt118")} isGray>
            <CardDocument
              documentName={userData.nameCurriculumDocument}
              documentUrl={userData.curriculumDocumentUrl}
            />
          </CardSummary>
        )}
      </section>
    </div>
  )
}